import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoBackChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 29,
	height: 54,
	viewBox: "0 0 0.94 1.77",
	fill: "#9095B5",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0.84 0.02c0.02,-0.03 0.06,-0.03 0.09,0 0.02,0.02 0.02,0.06 0,0.09l-0.78 0.77 0.78 0.78c0.02,0.02 0.02,0.06 0,0.09 -0.03,0.02 -0.07,0.02 -0.09,0l-0.82 -0.82c-0.03,-0.03 -0.03,-0.07 0,-0.09l0.82 -0.82z" })
});
export default SvgIcoBackChevron;
